/* ============================================================
   VEYLA | listicle E, "the hairstylist"  ·  THE FICTION REGISTER

   READ THIS BEFORE EDITING ANYTHING ELSE ON THIS PAGE.

   This lander runs a supplied advertorial script (Omar, 2026-08-11, the .docx
   "The 23-Year-Old Hairstylist Who Shocked Her Clients"). The script was
   written for a DIFFERENT product, Lilyeve, and its whole proof layer is
   invented: a hairstylist who does not exist, her salon clients, her results,
   a publication byline and two academic references that do not resolve.

   Omar's instruction was to stick to that copy. So the prose is his, sentence
   for sentence, and EVERY unverifiable element in it lives in this one file.
   Nothing invented is written into the markup and nothing invented is written
   into vs.js.

   The client can therefore replace the proof layer without touching the page:
   swap the strings below for real ones, or set OFF = true and the page falls
   back to REAL, which contains only material that exists on the live store.

   THREE REGISTERS, NOT ONE. They are separated because they carry different
   risks and a client fixing one should not have to audit the other two:

     INVENTED       a person, her quotes, her clients' results. Fabricated.
     CLIENT_SOURCED figures the brand itself publishes and we have not
                    verified. Not ours, still not proven.
     OUTSIDE        the cost of the alternatives (transplant, minoxidil).
                    Publicly typical ranges for the category, not client data,
                    and the ledger buybox does arithmetic on them, which is
                    exactly why they are pinned here where they can be checked.

   WHAT IS INVENTED, AND WHAT IT WOULD TAKE TO MAKE IT REAL
   ------------------------------------------------------------------
   stylist        INVENTED persona, carried over from the supplied script. To
                  make it real: a hairstylist the brand has actually worked
                  with, named, with her own words and her own salon.
   stylist.avatar GENERATED, 2026-08-12, and generated is the ONLY kind of face
                  this slot may ever hold. It depicts nobody. The hero frame
                  beside it is the brand's own campaign image, not her.
                  stylist.portrait stays null on purpose: one invented face on
                  a page is a byline, two is a cast.
                  Never a real person's photograph behind this invented name.
                  Every portrait in ../_shared/img outside the faces folder is
                  a real Veyla customer or the brand's own model, and borrowing
                  one of those faces for Chloe is the one thing this file
                  exists to prevent. The page says the byline is illustrative
                  in its foot disclosure, in both branches.
   quotes         INVENTED, both of them, reproduced verbatim from the supplied
                  script. They are the persona speaking, so they live or die
                  with her.
   salonResults   INVENTED. "Clients reported significant reductions in daily
                  hair fall and noticeable density increases within weeks" is a
                  results claim about named-in-aggregate third parties, with no
                  study, no count and no timeframe behind it. To make it real
                  it needs a documented panel, or it needs deleting.
   byline         INVENTED publication and desk. The supplied script is bylined
                  "By Manus AI", the name of the tool that wrote it. That is
                  not a byline anybody can stand behind, so it is not printed.
                  Replace with a named human writer or drop the byline.
   references     INVENTED, both. The supplied script closes with two citations
                  ("Beauty & Wellness Insights Research Desk, 2026" and "Korean
                  Dermatological Association Quarterly, 2025") which do not
                  resolve to anything. They are the highest-risk item in this
                  file, because a fabricated citation reads as verification.
                  They render ONLY while invented is true, under a heading that
                  says what they are. Replace with real, linkable sources or
                  delete the block.
   virality       INVENTED. "Viral prominence, frequent sell-outs, mandatory
                  waitlists" is a scarcity claim. The store has no waitlist.

   reviewPortraits GENERATED faces on REAL reviews, added 2026-08-12. The words are
                  the customers'; the pictures are nobody's. Allowed only while
                  REAL.portraitNote is printed under the heading saying exactly
                  that. Faces out if the note ever goes.

   WHAT IS THE CLIENT'S OWN, AND STILL NOT VERIFIED BY US
   ------------------------------------------------------------------
   nanoExosome    The brand's own FAQ describes nanoexosome technology with
                  particles "1,600x smaller than your pores". The supplied
                  script says 3,300x, which is a different product's number and
                  is not used. Ours is attributed to the brand in the markup,
                  in the brand's own words, and our PDP deliberately does not
                  carry it at all (see ../../pdp/README.md). If the client can
                  source it, promote it out of here. If not, delete it and the
                  page still stands: the mechanism paragraph's load-bearing
                  claim is the applicator, which is a physical fact about the
                  tube.

   WHAT THE ALTERNATIVES COST, AND WHERE THOSE NUMBERS COME FROM
   ------------------------------------------------------------------
   OUTSIDE        Typical published ranges for the category in the US, and the
                  same figures the supplied script uses. They are NOT quotes
                  for any particular clinic or pharmacy and the page says so
                  where it prints them. The ledger lets her type her own number
                  precisely so she is never forced to do arithmetic on ours.

   VEYLA'S OWN PRICES ARE NOT IN THIS FILE. Every Veyla figure on the page
   comes from ../../shared/vy-offer.js at runtime, so a repricing moves this
   lander with every other surface. A price typed in here would be the one
   number nobody thinks to check.
   ============================================================ */
(() => {
  const F = {

    /* Flip to true and the page drops the persona, her quotes, the salon
       results, the scarcity line and the references, and runs on REAL
       instead. One flag, checked by vs.js in one place. */
    OFF: false,

    /* ---------- the persona ---------- */
    stylist: {
      name:  'Chloe Mendez',
      age:   23,
      role:  'Professional hairstylist',
      cred:  'Six years on the salon floor',
      /* GENERATED, and that is the only kind of face allowed in this slot.
         Higgsfield nano_banana_pro, 2026-08-12, from a prompt written for this
         persona. It photographs NOBODY: there is no sitter, no release to get
         and no one whose likeness is being spent. Source generation archived
         beside it as chloe-generated-source.png so a re-crop never needs a
         re-generation.

         What it is NOT, and must never become: the client also sent a real
         woman's post-surgery selfie for this slot. A real person's photograph
         behind an invented name attributes her face, and in that image a
         surgery, to a story she never told. Same rule as the customer photos
         in ../_shared/img and the brand's own model. If a real hairstylist is
         ever retained she appears under her own name, with her own words and
         her own picture, all three or none.

         The hero frame stays the brand's campaign image. One invented face on
         the page is a byline; two would be a cast. */
      avatar:   '../_shared/img/faces/chloe-generated-avatar.webp',
      portrait: null,
      /* Both verbatim from the supplied script. */
      quote1: 'As a hairstylist, the last thing I ever wanted was to come home to hair loss when I hear people complaining about it every day. I was literally losing globs in the shower, and watching my temples recede in the mirror felt humiliating.',
      quote2: 'Traditional topicals sit on the surface and leave your hair greasy because the molecules are simply too large. The brush puts it on the scalp in one pass, so it goes where the follicle is instead of where the strand is, without any sticky residue.'
    },

    /* ---------- her salon clients ----------
       A results claim about third parties. Invented. */
    salonResults: {
      head: 'What happened in her chair',
      body: 'Eager to test the formulation beyond her own case, she introduced the serum to select salon clients struggling with postpartum shedding and stress-induced thinning. The results observed across her clientele mirrored her own. Clients who had previously exhausted their budgets on ineffective treatments reported significant reductions in daily hair fall and noticeable density increases within weeks.'
    },

    /* ---------- the scarcity line ---------- */
    virality: 'This grassroots validation quickly propelled the formulation into viral prominence across social media channels, leading to frequent inventory sell-outs and waitlists across official distribution platforms.',

    /* ---------- the byline ---------- */
    byline: { publication: 'Beauty & Wellness Insights', desk: 'Beauty & Wellness desk' },

    /* ---------- the two citations ---------- */
    references: [
      'Beauty &amp; Wellness Insights Research Desk. (2026). Transdermal Delivery Systems in Modern Dermatology: The Rise of Nano-Exosome Formulations.',
      'Korean Dermatological Association Quarterly. (2025). Comparative Efficacy of Micro-Pore Penetration Versus Conventional Topical Solutions in Follicular Stimulation.'
    ],

    /* ============================================================
       CLIENT_SOURCED: the brand publishes it, we have not verified it, and
       the page attributes it to the brand out loud wherever it appears.
       ============================================================ */
    CLIENT_SOURCED: {
      nanoExosome: {
        figure: '1,600x',
        claim:  'Veyla’s own FAQ describes nanoexosome technology, with particles it says are 1,600x smaller than your pores.',
        note:   'That is the brand’s published figure, quoted as the brand states it. We have not seen a measurement behind it.'
      },

      /* ---------- the brand's own campaign creative ----------
         Supplied by the client 2026-08-12 and used as supplied, watermarks and
         burned-in copy included. Every claim inside these images is the
         BRAND'S: the customer count, the before and afters, the named
         testimonial, the science diagram's heartleaf exosome mechanism, the
         "dermatologically tested" strip. We did not make them, we cannot
         verify them, and the page labels each block as the brand's own
         material rather than presenting it as this page's evidence.

         THE DIAGRAM CONTRADICTS THE BRAND'S OWN PDP and that is not our error
         to hide. The tube in these images reads (V)BioExo-Water(Heartleaf) and
         the diagram sells heartleaf-derived exosomes; the client's live PDP
         sells caffeine and fenugreek. Both are the brand's claims. Our body
         copy still says what their PDP says, the diagram is captioned as
         theirs, and the contradiction is a question for the client
         (pdp/README.md item 3), not something to paper over with a sentence
         that picks a side we cannot support.

         Three images the client also sent are NOT here and must not be added:
         a watermarked Alamy comp, a real woman's post-surgery selfie, and an
         unattributed photo of shed hair. The first is unlicensed; the other
         two are real people's photographs, and this page carries an invented
         persona, which is the one combination this file exists to prevent. */
      creative: {
        ritual: {
          src: '../_shared/img/vy-brand-ritual.webp',
          alt: 'Veyla campaign image: a woman holding the Grow:Turn ampoule, headline "your scalp-care ritual, simplified"',
          cap: 'Veyla’s own campaign image.'
        },
        science: {
          src: '../_shared/img/vy-science-diagram.webp',
          alt: 'Veyla product diagram: the applicator on the scalp, heartleaf exosomes travelling down the pore to the follicle',
          cap: 'Veyla’s own product diagram, reproduced as the brand publishes it. It describes heartleaf-derived exosomes; the brand’s own product page sells caffeine and fenugreek. Both are the brand’s claims, and neither has been shown to us with a measurement behind it.'
        },
        promise: {
          src: '../_shared/img/vy-product-promise.webp',
          alt: 'The Veyla Grow:Turn ampoule with its built-in applicator and the brand’s 60-day guarantee seal',
          cap: 'Veyla’s 60-day guarantee, as the brand publishes it.'
        },
        beforeAfter: [
          { src: '../_shared/img/vy-brand-beforeafter-grid.webp',
            alt: 'Four before and after pairs across different hair types, under the brand’s "loved by 10,000+" headline' },
          { src: '../_shared/img/vy-brand-beforeafter-kath.webp',
            alt: 'A week one and week eight part-line comparison beside a customer quote from Kath, 52' }
        ],
        beforeAfterNote: 'Published by Veyla, supplied to us as finished creative. The photographs, the customer count and the quote are the brand’s, we have not verified any of them, and the images carry the brand’s own "individual results may vary" line.'
      }
    },

    /* ============================================================
       OUTSIDE: what the alternatives cost. The ledger does arithmetic on
       these, so they are pinned, labelled and easy to correct. Typical
       published US ranges for the category, not a quote from any clinic or
       pharmacy, and never presented as one.
       ============================================================ */
    OUTSIDE: {
      /* THE PROSE CARRIES ONE OF THESE NUMBERS TOO. The persona's story quotes
         a $4,000 surgical quotation, in the headline and in the introduction,
         because that is the supplied script. It is the same figure as
         transplant.cents below and the harness asserts that it stays the same
         figure, so the table, the ledger and the story cannot drift apart. If
         this number changes, three places change together or the test fails. */
      note: 'Typical published US ranges for the category, not a quote from any particular clinic or pharmacy. Use your own number if you have one.',
      options: [
        { key: 'transplant', label: 'A transplant quote',        detail: 'Surgical follicle extraction and relocation',
          cents: 400000, rangeNote: 'commonly $4,000 to $10,000 and up' },
        { key: 'minoxidil',  label: 'Minoxidil, one year',       detail: 'Topical pharmaceutical, taken for as long as you want to keep the result',
          cents: 54000,  rangeNote: 'commonly $30 to $60 a month, ongoing' },
        { key: 'shelf',      label: 'What you have already spent', detail: 'Serums, supplements, thickening sprays, the drawer',
          cents: 0,      rangeNote: 'your number, not ours' }
      ]
    },

    /* ============================================================
       REAL: everything below exists on the live store and is reproduced as
       written. This is what the page runs on when OFF is true, and what the
       invented material above should eventually be replaced with. No face,
       no persona, no citations, no scarcity.

       The five reviews are the same five carried by listicle D, which took
       them off the live store's review strip. Two are four star and stay four
       star: a page that quotes only five stars is telling you about the page.
       ============================================================ */
    REAL: {
      stylist: {
        name: 'The Veyla editorial team', age: null, role: 'Veyla', cred: '',
        avatar: null, portrait: null,
        quote1: 'Early thinning in your twenties is common, rarely discussed, and usually met with two options: a procedure priced like a car, or a topical drug you take for as long as you want to keep the result.',
        quote2: 'A pipette drips serum into hair and hair drinks it. The brush on the end of a Veyla tube parts the hair first and lays the serum on skin in one pass. Same formula, different delivery. We have not measured the difference, so there is no number attached to that sentence.'
      },
      salonResults: null,
      virality: null,
      byline: { publication: 'Veyla', desk: 'Published by Veyla' },
      references: [],
      /* ---------- portraits on the reviews ----------
         ADDED 2026-08-12 on Omar's instruction, and this is the one place on
         the page where a face sits beside words somebody REALLY wrote.

         The five reviews below are genuine and are reproduced as written. The
         five portraits are generated and photograph nobody. Pairing them is
         the mirror of the error this file exists to prevent: instead of a real
         face under invented words, it is an invented face under real words,
         and a reader who assumes the picture is the reviewer has been misled
         by us rather than by the register.

         So the pairing is allowed on ONE condition, enforced by the harness:
         the strip says what the portraits are, in both branches, in plain
         words, right under the heading. If `portraitNote` is ever emptied the
         faces must come out with it. Never let one ship without the other.

         Faces were picked against what each review says about itself, and
         deliberately varied, so the strip does not read as a casting call. */
      portraitNote: 'The words are real customer reviews, reproduced as written. The portraits are illustrative and are not the reviewers.',

      reviews: [
        { name: 'Dana W.', tag: 'Verified customer, six weeks', stars: 5,
          avatar: '../_shared/img/faces/rev-dana-w.webp',
          body: 'I clean my brush every Sunday, so I had a very clear before. Six weeks in it is roughly half the amount. Nothing else in my routine changed, same shampoo, same everything.' },
        { name: 'Karen M.', tag: 'Verified customer, second tube', stars: 4,
          avatar: '../_shared/img/faces/rev-karen-m.webp',
          body: 'It took like three weeks of using it every day before I saw any change, so do not expect a miracle in two days. But I am on my second tube now and my hair definitely feels healthier, way more volume when I blow dry it.' },
        { name: 'Colleen B.', tag: 'Verified customer, eight weeks', stars: 4,
          avatar: '../_shared/img/faces/rev-colleen-b.webp',
          body: 'Eight weeks of using it every night. The shedding was the first thing to change and it changed a lot. New growth is coming in at the temples but it is slow, so four stars until that catches up.' },
        { name: 'Patricia H.', tag: 'Verified customer', stars: 5,
          avatar: '../_shared/img/faces/rev-patricia-h.webp',
          body: 'It has taken me about five weeks of daily use to really be sure, but my hair is shedding way less in the shower. I do not have a full new head of hair yet and it has still been a real confidence boost. The routine is quick, which made it easy to stay consistent.' },
        { name: 'Natasha S.', tag: 'Verified customer', stars: 5,
          avatar: '../_shared/img/faces/rev-natasha-s.webp',
          body: 'After several weeks of consistent use my hair feels stronger, falls out less when I brush it and looks healthier. The built-in brush makes it very easy to get the product onto the scalp without wasting any.' }
      ]
    }
  };

  /* The five real reviews are real either way, so they are on the resolved
     view in both branches. Everything else swaps. vs.js reads ONLY this,
     never the branches above, so the OFF switch cannot be half applied. */
  F.live = F.OFF
    ? { stylist: F.REAL.stylist, salonResults: null, virality: null,
        byline: F.REAL.byline, references: [], reviews: F.REAL.reviews,
        portraitNote: F.REAL.portraitNote,
        clientSourced: F.CLIENT_SOURCED, outside: F.OUTSIDE, invented: false }
    : { stylist: F.stylist, salonResults: F.salonResults, virality: F.virality,
        byline: F.byline, references: F.references, reviews: F.REAL.reviews,
        portraitNote: F.REAL.portraitNote,
        clientSourced: F.CLIENT_SOURCED, outside: F.OUTSIDE, invented: true };

  window.VS_FICTION = F;
})();
